import { Component, OnInit } from '@angular/core';
import {environment} from '../../environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  public state: string = environment.state;
  currentRoute = 'login';

  constructor(private router: Router) { }

  ngOnInit() {
    this.currentRoute = this.router.url.replace('/', '');
  }

}
